import { createBrowserRouter } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import ProfilePage from "./components/ProfilePage";
import AdminPanel from "./components/AdminPanel";
import AdminRoute from "./components/AdminRoute";
import NewsDetail from "./components/NewsDetail";
import MemberArea from "./components/MemberArea";
import ProfileEdit from "./components/ProfileEdit";
import Avatar from "./pages/Avatar";
import PasswordReset from "./pages/PasswordReset";
import OnboardingStart from "./pages/OnboardingStart";
import Activation from "./pages/Activation";
import OnboardingAdmin from "./components/OnboardingAdmin";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Layout />,  // Layout gère la navbar/footer
        children: [
            { index: true, element: <Home /> },  
            { path: "profile/:id", element: <ProfilePage /> },
            // { path: "admin", element: <AdminPanel /> },
            { path: "news/:id", element: <NewsDetail /> },
            { path: "members-area", element: <MemberArea /> }, 
            { path: "mon-profil", element: <ProfileEdit /> },
        ],
    },
    { path: "admin", element: <AdminRoute><AdminPanel /></AdminRoute> },
    { path: "admin/onboarding", element: <AdminRoute><OnboardingAdmin /></AdminRoute> },
    { path: "activer-mon-compte", element: <OnboardingStart /> },
    { path: "activation", element: <Activation /> },
    { path: "reset", element: <OnboardingStart /> }, // alias : ancienne page d'onboarding
    { path: "password-reset", element: <PasswordReset /> },
    // { path: "AutoVulves", element: <AutoVulves /> }, 
    // { path: "Vulves", element: <Vulves /> }, 
    // { path: "Vulve", element: <Vulve /> }, 
    { path: "Avatar", element: <Avatar /> }, 
]);

export default router;
